import React from "react";
import { Typography } from "antd";
import QuestionTracker from "../questionTracker/QuestionTracker";
import { useLocation } from "react-router-dom";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import { useCurrentApplication } from "../../../../Context/CurrentApplicationContext/CurrentApplicationContext";

interface ActionStepperProps {}

const ActionStepper: React.FC<ActionStepperProps> = () => {
  const location = useLocation();

  const {rounds,interviewSessions} = useCurrentApplication();
  const {
    currentStep,
    isRoundFinished,
    aiAssessmentQuestions,
    aiAssessmentDetails,
  } = useAIAssessmentContext();

  const isShowInfo = isRoundFinished || currentStep >= 0;

  const getCurrentStep = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const searchParams = new URLSearchParams(location.search);

    if (pathSegments.includes("result")) return "result";
    if (pathSegments.includes("online-interview")) return "online-interview";
    if (pathSegments.includes("interview-round")) {
      const sessionId = searchParams.get("sessionId");
      if (sessionId) {
        return `session-${sessionId}`;
      }
      return "interview-round";
    }
    if (pathSegments.includes("requirements")) return "requirements";
    return "requirements";
  };

  const getCurrentRound = () => {
    const currentStep = getCurrentStep();
    if (currentStep.startsWith("session-")) {
      const sessionId = currentStep.replace("session-", "");
      const activeRound = interviewSessions.find(
        (round) => round._id === sessionId
      );
      return activeRound?.interviewRoundNumber || 1;
    }
    return (
      1
    );
  };

  const currentRound = getCurrentRound();
  const totalRounds = rounds.length;
  const answeredCount = aiAssessmentQuestions.filter(
    (question) =>
      question.answer !== null &&
      question.answer !== undefined &&
      question.answer.trim().length > 0
  ).length;
  const unansweredCount = aiAssessmentQuestions.filter(
    (question) =>
      question.answer === null ||
      question.answer === undefined ||
      question.answer.trim().length === 0
  ).length;

  return (
    <div className="action-stepper-container">
      <div className="action-stepper-info">
        <Typography.Title level={5} style={{ margin: "0px", fontSize: "14px" }}>
          Round {currentRound} of {totalRounds}
        </Typography.Title>
        {isShowInfo && (
          <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
            {aiAssessmentDetails?.noOfQuestions} questions
          </Typography.Text>
        )}
      </div>

      <div className="action-stepper-tracker">
        <QuestionTracker />
      </div>

      {isShowInfo && (
        <div className="action-stepper-stats-container">
          <div className="stats-item answered">
            {answeredCount}
            <span>Answered</span>
          </div>
          <div className="stats-item unanswered">
            {unansweredCount}
            <span>Unanswered</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionStepper;
